import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';

import { LOCAL_CONTENT_MAX_WIDTH } from 'styles/constants';
import getContrastingColor from 'utils/getContrastingColor';

export const OuterContainer = styled.div<{ backgroundColor: string }>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  --text-color: ${({ backgroundColor }) =>
    backgroundColor && getContrastingColor(backgroundColor)};

  h1,
  p,
  small {
    color: var(--text-color);
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${LOCAL_CONTENT_MAX_WIDTH};
  margin: 0 auto;
  align-items: center;

  ${MEDIA_QUERIES.mdUp} {
    flex-direction: row;
  }
`;

export const MediaContainer = styled.div`
  --aspect-ratio-mobile: 375 / 375;
  --aspect-ratio-desktop: 641 / 641;
  width: 100%;
  overflow: hidden;
  aspect-ratio: var(--aspect-ratio-mobile);

  ${MEDIA_QUERIES.mdUp} {
    max-width: 50%;
    aspect-ratio: var(--aspect-ratio-desktop);
    max-height: 641px;
  }

  .gatsby-image-wrapper,
  img {
    aspect-ratio: var(--aspect-ratio-mobile);
    object-fit: cover;

    ${MEDIA_QUERIES.mdUp} {
      aspect-ratio: var(--aspect-ratio-desktop);
    }
  }
`;

export const ContentContainer = styled.div<{ hideMobileCtaButton?: boolean }>`
  width: 100%;
  padding: ${SPACER.x4large} ${SPACER.large}
    ${({ hideMobileCtaButton }) => (hideMobileCtaButton ? 0 : SPACER.large)} 0;

  ${MEDIA_QUERIES.mdUp} {
    width: 50%;
    padding: ${SPACER.x2large};
  }

  ${MEDIA_QUERIES.lgUp} {
    padding: ${SPACER.x5large} 4.5rem;
  }
`;

export const HeaderContainer = styled.h1`
  margin-bottom: ${SPACER.large};

  ${MEDIA_QUERIES.mdUp} {
    margin-bottom: ${SPACER.base};
  }
  sup {
    font-size: 1.5rem;
  }
`;

export const bodyStyles = css`
  margin-bottom: ${SPACER.medium};
  max-width: 430px;

  & > * {
    margin-bottom: ${SPACER.xlarge};
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const TagsContainer = styled.div`
  margin-bottom: ${SPACER.medium};

  h4 {
    margin-bottom: ${SPACER.small};
  }
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${SPACER.xsmall};
`;

export const Checklist = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${SPACER.small};
  margin-bottom: ${SPACER.medium};

  li {
    display: flex;
    align-items: center;
    gap: ${SPACER.medium};
  }
`;
